import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function searchAIPrompt(searchFormData) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/AI/searchPrompt',
    data: sanitizePostData(searchFormData),
    generalErrorsOnly: true,
  });
  return data;
}

async function createActivityCVFromPrompt(activityId, prompt) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/AI/createActivityCVFromPrompt',  
    data: sanitizePostData({ activityId, prompt }),
    generalErrorsOnly: true,
  });
  return data;
}

async function createCVForUser(activityCVMap) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/AI/createCVForUser',  
    data: sanitizePostData({ activityCVMap }),
    generalErrorsOnly: true,
  });
  return data;
}

export {
    searchAIPrompt,
    createActivityCVFromPrompt,
    createCVForUser
}